<template>
  <item-form />
</template>

<script>

import ItemForm from '@/views/Projects/ItemForm.vue'

export default {
  name: 'Add',
  components: {
    ItemForm,
  },
}
</script>
